import { defineStore } from 'pinia';
import type { IUserPermissions } from '../types/IPermissions';
import type { IRole } from '../types/IRole';

const defaultPermissions: IUserPermissions = {
  admin: {
    read: false,
    write: false
  },
  config: {
    read: false,
    write: false
  },
  data: {
    read: false,
    contracts: {
      read: false,
      write: false
    },
    facilities: {
      read: false,
      write: false
    },
    sketch: {
      read: false,
      write: false
    },
    domains: {
      read: false,
      write: false
    },
    cost_accounts: {
      read: false,
      write: false
    },
    partners: {
      read: false,
      write: false
    }
  },
  deviceUserSketchView: 'self'
};

interface AuthState {
  userName: string;
  userId: number;
  role: number;
  logedIn: boolean;
  userReplaced: boolean;
  sceneReload: boolean;
  permissions: IUserPermissions;
  clientName: string;
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    userName: 'unknown',
    userId: -1,
    role: -1,
    logedIn: false,
    userReplaced: false,
    sceneReload: false,
    permissions: defaultPermissions,
    clientName: '',
  }),
  actions: {
    login(userData: { name: string; deviceuser_id: number; role: number; permissions: string }) {
      this.userName = userData.name;
      if (this.userId > 0 && this.userId != userData.deviceuser_id) {
        this.userReplaced = true;
        this.sceneReload = true;
      }
      this.userId = userData.deviceuser_id;
      this.role = userData.role;
      this.logedIn = true;
      try {
        const permissions = JSON.parse(userData.permissions);
        this.permissions = Object.assign(this.permissions, permissions);
      } catch (e) {
        console.log(e);
        this.permissions = defaultPermissions;
      }
    },
    logout() {
      this.logedIn = false;
    },
    loggedIn() {
      this.userReplaced = false;
    },
    refreshPermissions(role: IRole) {
      if (this.role == role._id) {
        const permissions = role.permissions ? JSON.parse(role.permissions!) : {};
        this.permissions = Object.assign(this.permissions, permissions);
      }
    },
    setClientName(name: string) {
      this.clientName = name;
    },
    sceneReloaded() {
      this.sceneReload = false;
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
